import { render, staticRenderFns } from "./clients.vue?vue&type=template&id=c32fc6ee&scoped=true&"
import script from "./clients.vue?vue&type=script&lang=js&"
export * from "./clients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32fc6ee",
  null
  
)

export default component.exports